// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"985":"ccb426b6","3216":"719c60fd","3641":"995d07fd","5277":"4e279870"}[chunkId] + ".css";
};